const comparisonData = [
  { feature: 'Product Discovery', superbuy: 'Organized & Curated', normal: 'Random & Scattered' },
  { feature: 'Research Speed', superbuy: 'Fast & Efficient', normal: 'Slow & Time-consuming' },
  { feature: 'Category Filtering', superbuy: 'Easy One-Click', normal: 'Difficult & Manual' },
  { feature: 'Beginner Experience', superbuy: 'Simple & Guided', normal: 'Complex & Confusing' },
  { feature: 'Information Updates', superbuy: 'Regular & Reliable', normal: 'Uncertain & Irregular' },
];

export default function ComparisonTable() {
  return (
    <section className="w-full py-20 md:py-28 px-4 md:px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 border border-foreground-200 rounded-full text-foreground-500 font-label text-xs font-medium mb-4">
            Comparison
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Superbuy Spreadsheet vs Normal Search
          </h2>
        </div>

        <div className="overflow-hidden rounded-2xl border border-background-200">
          <table className="w-full">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-6 py-4 font-label text-sm font-semibold text-foreground-700">Feature</th>
                <th className="text-left px-6 py-4 font-label text-sm font-semibold text-accent-800">
                  <i className="ri-star-fill text-xs mr-1"></i> Superbuy Spreadsheet
                </th>
                <th className="text-left px-6 py-4 font-label text-sm font-semibold text-foreground-500">Normal Search</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={row.feature} className={idx % 2 === 0 ? 'bg-background-50' : 'bg-white'}>
                  <td className="px-6 py-4 text-sm font-medium text-foreground-800">{row.feature}</td>
                  <td className="px-6 py-4 text-sm text-accent-800 font-medium">{row.superbuy}</td>
                  <td className="px-6 py-4 text-sm text-foreground-500">{row.normal}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}